import { Pipe, PipeTransform, inject } from '@angular/core';
// TODO: The old App is used "duo-tone" icons. Recheck if it is necessary
import { cfaTrashShovel } from '../../../assets/icons/custom-fa-icons';
import { IconKey } from '../../../whitelabel/icon-key.enum';
import { LanguageService } from '../../core/services/language.service';
import { ContactType } from '../../pages/resources/contacts/enums/contact-type.enum';
import { IconProviderService } from '../../whitelabel/services/icon-provider.service';

@Pipe({
  name: 'contactType',
  standalone: true,
})
export class ContactTypeResolverPipe implements PipeTransform {
  private languageService = inject(LanguageService);
  private iconProviderService = inject(IconProviderService);

  private definitionSet = {
    [ContactType.GENERIC]: {
      name: this.translate('modules.contact.base.contactType.generic'),
      icon: this.iconProviderService.getIcon(IconKey.ContactTypeGeneric),
    },
    [ContactType.COMPANY]: {
      name: this.translate('modules.contact.base.contactType.company'),
      icon: this.iconProviderService.getIcon(IconKey.ContactTypeCompany),
    },
    [ContactType.CO_CONTRACTOR]: {
      name: this.translate('modules.contact.base.contactType.coContractor'),
      icon: this.iconProviderService.getIcon(IconKey.ContactTypeCoContractor),
    },
    [ContactType.GRAVEL_PLANT]: {
      name: this.translate('modules.contact.base.contactType.gravelPlant'),
      icon: this.iconProviderService.getIcon(IconKey.ContactTypeGravelPlant),
    },
    [ContactType.LANDFILL]: {
      name: this.translate('modules.contact.base.contactType.landfill'),
      icon: this.iconProviderService.getIcon(IconKey.ContactTypeLandfill),
    },
    [ContactType.LOCATION]: {
      name: this.translate('modules.contact.base.contactType.location'),
      icon: this.iconProviderService.getIcon(IconKey.ContactTypeLocation),
    },
    [ContactType.LANDFILL_GRAVEL_PLANT]: {
      name:
        this.translate('modules.contact.base.contactType.landfill') +
        ' / ' +
        this.translate('modules.contact.base.contactType.gravelPlant'),
      icon: cfaTrashShovel,
    },
  };

  transform(value: ContactType): string {
    return this.resolveName(value);
  }

  resolveName(type: ContactType): string {
    return this.definitionSet[type]?.name ?? this.translate('general.unknown');
  }

  resolveIcon(type: ContactType): string {
    return (this.definitionSet[type]?.icon as string) ?? this.iconProviderService.getIcon(IconKey.ContactTypeUnknown);
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
